var path = '/var/www/mmscny-website/src/app/common/components/select-dropdown/select-dropdown.html';
var html = "<div class=select-dropdown-section aria-haspopup=true role=combobox> <div class=\"form-group select-wrapper\" aria-label=\"{{$ctrl.title}} dropdown section\"> <label>{{ $ctrl.title }}</label> <select ng-model=$ctrl.optionId ng-options=\"option.id as option.name for option in $ctrl.options\" class=form-control ng-class=\"{'arrow-green':$ctrl.arrowColor === 'green','arrow-white':$ctrl.arrowColor === 'white'}\" id=dropdown ng-required=$ctrl._isRequired ng-change=$ctrl._onChange()> <option value=\"\">{{$ctrl.placeholder}}</option> </select> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/select-dropdown/select-dropdown.html
// module id = 662
// module chunks = 0